import { Reveal } from "@/lib/motion";
import { Chapter } from "./Chapter";
import { LEADERSHIP } from "@/data/content";
import { ExternalLink } from "lucide-react";

export const Leadership = () => (
  <section id="leadership" className="relative z-10 py-24 md:py-32 lg:py-40">
    <div className="max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-20">
      <Chapter num="05" title="Leadership & community" kicker="Beyond the data" />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {LEADERSHIP.map((l, i) => (
          <Reveal key={l.title} delay={i * 0.1}>
            <div className="group h-full border-t-2 border-[#16324f] pt-6 hover:pt-4 transition-[padding] duration-500">
              <span className="font-mono-plex text-[12.5px] text-[#b5423a]">{`0${i + 1}`}</span>
              <h3 className="font-serif-display text-[22px] text-[#16324f] leading-snug mt-3">{l.title}</h3>
              <p className="mt-1.5 font-mono-plex text-[13px] text-[#2e7d6b]">{l.org}</p>
              <p className="mt-4 text-[15px] text-[#3a4d5c] leading-relaxed">{l.desc}</p>
              {l.pdf && (
                <a
                  data-testid={`leadership-cert-link-${i}`}
                  href={`${l.pdf}#zoom=33`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-5 inline-flex items-center gap-1.5 font-mono-plex text-[11px] uppercase tracking-[0.12em] text-[#b5423a] hover:text-[#16324f] transition-colors duration-300"
                >
                  <ExternalLink size={12} /> View certificate
                </a>
              )}
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
